import React, { useState, memo } from 'react';
import { motion } from 'framer-motion';
import Button from '../components/Button';
import { SparklesIcon, ArrowRightIcon, CodeIcon, VideoIcon, TrendingUpIcon, RocketIcon, FilmIcon } from 'lucide-react';
const Projects = () => {
  const [hoveredProject, setHoveredProject] = useState<number | null>(null);
  const categories = [{
    id: 'all',
    name: 'Todos',
    icon: <SparklesIcon className="h-5 w-5" data-id="element-451" />
  }, {
    id: 'launch',
    name: 'Lanzamientos',
    icon: <RocketIcon className="h-5 w-5" data-id="element-452" />
  }, {
    id: 'series',
    name: 'Series',
    icon: <FilmIcon className="h-5 w-5" data-id="element-453" />
  }, {
    id: 'prototype',
    name: 'Prototipos',
    icon: <CodeIcon className="h-5 w-5" data-id="element-454" />
  }, {
    id: 'campaign',
    name: 'Campañas',
    icon: <TrendingUpIcon className="h-5 w-5" data-id="element-455" />
  }];
  const [selectedCategory, setSelectedCategory] = useState('all');
  const projects = [
  // Lanzamientos y Producciones
  {
    id: 1,
    title: 'Centenario Mazda Guatemala',
    category: 'launch',
    description: 'Cobertura completa del Centenario de Mazda con un crew de 7 personas. Toda la línea gráfica, videos y diseño en pantallas LED fue trabajado por nuestra agencia. Recibimos reconocimiento desde Japón como el mejor material a nivel Latinoamérica.',
    client: 'Mazda Guatemala',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/fdfWC85mgmRBF6sZwYAeXx/_RFX8588.jpg',
    gradient: 'from-red-600 to-orange-600'
  }, {
    id: 2,
    title: 'Lanzamiento All New Peugeot 2008',
    category: 'launch',
    description: 'Nuestra primera producción de gran presupuesto y alcance internacional. El mejor lanzamiento de la SUV 2008 a nivel Latinoamérica en 2020. Siete días de producción con un crew de 15 personas, nuestra primera producción con equipo de cine.',
    client: 'Peugeot Guatemala',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/6F7wWvwJ7NejJiQVguv9BM/Lanzamiento_All_New_Peugeot_2008.jpg',
    gradient: 'from-blue-600 to-cyan-600'
  }, {
    id: 3,
    title: 'Lanzamiento All New Mazda BT-50',
    category: 'launch',
    description: 'En 2021, Mazda Motors Company desde Japón solicitó que nuestra agencia produjera este lanzamiento. Producción llevada a cabo en cinco departamentos de Guatemala, incluyendo Los Cuchumatanes, extendiéndonos a Panamá y República Dominicana.',
    client: 'Mazda Motors Company',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/sPBFRUxFvSPzMRUoZBy16v/Lanzamiento_All_New_Mazda_BT-50.jpg',
    gradient: 'from-purple-600 to-pink-600'
  }, {
    id: 4,
    title: 'Lanzamiento All New Landtrek',
    category: 'launch',
    description: 'Rally de lanzamiento del Pickup Peugeot Landtrek en 2022. Recorrimos tres departamentos con un crew de 5 personas y 3 vehículos, visitando lugares emblemáticos como Represa Chixoy, Semuc Champey, Isla de Flores y Río Dulce. Transmitido en vivo a toda Centroamérica.',
    client: 'Peugeot Guatemala',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/4u6getFS25kVDyxbyaAx8H/Lanzamiento_All_New_Landtrek.jpg',
    gradient: 'from-green-600 to-teal-600'
  },
  // Series y Cortometrajes
  {
    id: 5,
    title: 'De Vuelta a Casa',
    category: 'series',
    description: 'Nuestro primer cortometraje, escrito, producido y dirigido por nosotros. Estrenado ante más de 700 jóvenes. Producción con 25 actores locales en tres departamentos del Nor-Oriente. Marcó un antes y después en la historia de Grupo Reflex.',
    client: 'Grupo Reflex',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/e6rC7EKPcfSD6aHW18qU1Y/de_vuelta_a_casa.jpg',
    gradient: 'from-indigo-600 to-purple-600'
  }, {
    id: 6,
    title: 'Cortometraje Reset',
    category: 'series',
    description: 'Cortometraje para crear conciencia sobre cómo las decisiones de los jóvenes pueden llevarlos a situaciones difíciles o incluso la muerte. Un mensaje de esperanza sobre cómo en Dios hay ayuda para sobreponerse a cada desafío.',
    client: 'Grupo Reflex',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/vTGcrFNj2cVpDpt8ngx16U/RESET.jpg',
    gradient: 'from-orange-600 to-red-600'
  }, {
    id: 7,
    title: 'Cortometraje Soy Discípulo',
    category: 'series',
    description: 'Cortometraje dedicado a resaltar lo que realmente significa seguir a Cristo en estos tiempos postmodernos. El mensaje de la Cruz sigue siendo relevante y la resurrección de Jesús sigue siendo un hecho ineludible.',
    client: 'Grupo Reflex',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/fE7JhZd7rzv6jxHMVR344Z/SOY_DISCIPULO.jpg',
    gradient: 'from-yellow-600 to-orange-600'
  }, {
    id: 8,
    title: 'Un Minuto desde el Río',
    category: 'series',
    description: 'Serie de 15 episodios, uno de nuestros casos de éxito. Trabajamos desde el concepto y nombre hasta la producción. Nuestro cliente vio su empresa subir más de 300% durante 25 semanas de publicación.',
    client: 'Confidencial',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/vkkUx35E2uDqHpSHmLEEh9/Un_Minuto_desde_el_Rio.jpg',
    gradient: 'from-cyan-600 to-blue-600'
  }, {
    id: 9,
    title: 'Chiquimula Impresionante',
    category: 'series',
    description: 'Uno de nuestros trabajos más recientes. Desde la idea creativa, concepto y nombre para promocionar una cadena hotelera de prestigio. Crew de 4 personas, 3 modelos internacionales y 4 días de producción para levantar el turismo de la región.',
    client: 'Caporal H&R',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/u67iQuWh3r2ZJQE9ovHDdt/IMG_0855.jpg',
    gradient: 'from-pink-600 to-purple-600'
  },
  // Prototipos
  {
    id: 10,
    title: 'Prototipo 3D Carreta Si Con Pepsi',
    category: 'prototype',
    description: 'Trabajo gratificante donde incursionamos en el modelaje 3D de prototipos que finalmente se construyeron y presentaron con gran éxito. Utilizamos softwares como Blender y Unreal Engine.',
    client: 'Pepsi Guatemala',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/i7UPGQrsqTWcLi6wrPiXo4/Prototipo_3D_Carreta_Si_Con_Pepsi.png',
    gradient: 'from-blue-600 to-indigo-600'
  }, {
    id: 11,
    title: 'Prototipo App DingDong',
    category: 'prototype',
    description: 'Proyecto en curso ya en etapa de prelanzamiento, buscando inversionistas. DingDong será para la industria de la paquetería lo que Uber fue para la industria de los taxis.',
    client: 'Grupo Reflex',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/2nkgYRbTziEWHEQTGjRADQ/Prototipo_App_DingDong.jpg',
    gradient: 'from-purple-600 to-pink-600'
  },
  // Campañas de Marketing
  {
    id: 12,
    title: 'Las 25 Rutas de Arrend',
    category: 'campaign',
    description: 'Campaña donde recorrimos todo Guatemala fotografiando sus lugares más impresionantes. Cerca de 30 videos durante un año, 200 fotografías y un libro conmemorativo del 25 aniversario de Arrend Leasing.',
    client: 'Arrend Leasing',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/4VxbkufdbiXtz3fXZwW9fR/Las_25_Rutas_de_Arrend.jpg',
    gradient: 'from-green-600 to-emerald-600'
  }, {
    id: 13,
    title: 'Campaña Electoral 2023',
    category: 'campaign',
    description: 'Proyecto híbrido de participación cívica. Más de 20 videos institucionales y cápsulas testimoniales en dos meses. Nuestra división de impresión trabajó sin interrupción imprimiendo más de 250 metros diarios durante dos meses.',
    client: 'Marlon Cornel',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/jEoNen7m9PkUTzh8eyKJow/Campana_Electoral_2023.jpg',
    gradient: 'from-red-600 to-pink-600'
  }, {
    id: 14,
    title: 'Mazda CX-Experience All New CX-60',
    category: 'campaign',
    description: 'Lanzamiento que afirmó el posicionamiento de Mazda Guatemala como marca premium en Centroamérica. Fuimos encargados de la cobertura y transmisión en vivo desde Oakland Mall para toda la región.',
    client: 'Mazda Guatemala',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/ovpbpT5qkZ3FwnoC3Jy8wR/Mazda_CX-Experience_All_New_CX-60.jpg',
    gradient: 'from-slate-600 to-gray-600'
  }, {
    id: 15,
    title: 'Plan de Lealtad App MiGrupoQ',
    category: 'campaign',
    description: 'Producción profesional de tres videos tipo spot para la división de CRM de Grupo Q. Utilizamos modelos y locaciones en Ciudad Capital. Concepto creativo completo, storytelling, storyboard y tres días de producción.',
    client: 'Grupo Q',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/1embcKcNjJAUvcgome6pPR/MIGRUPOQ.png',
    gradient: 'from-orange-600 to-yellow-600'
  }];
  const filteredProjects = selectedCategory === 'all' ? projects : projects.filter(p => p.category === selectedCategory);
  return <>
      {/* Hero Section */}
      <section className="relative h-screen flex items-center justify-center overflow-hidden" data-id="element-456">
        <div className="absolute inset-0" data-id="element-457">
          <img src="https://images.unsplash.com/photo-1552664730-d307ca884978?ixlib=rb-4.0.3&auto=format&fit=crop&w=2070&q=80" alt="Proyectos" className="w-full h-full object-cover" data-id="element-458" />
          <div className="absolute inset-0 bg-gradient-to-b from-gray-900/90 via-purple-900/85 to-gray-900/90" data-id="element-459"></div>
        </div>
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 1
      }} className="container mx-auto px-4 md:px-6 relative z-10 text-center" data-id="element-460">
          <div className="flex items-center justify-center mb-6" data-id="element-461">
            <SparklesIcon className="h-12 w-12 text-purple-400 mr-4" data-id="element-462" />
            <h1 className="text-5xl md:text-7xl font-bold text-white" data-id="element-463">
              Nuestros Proyectos
            </h1>
          </div>
          <p className="text-xl md:text-2xl text-gray-300 max-w-3xl mx-auto" data-id="element-464">
            Cada proyecto es una{' '}
            <span className="bg-gradient-to-r from-purple-400 to-pink-400 bg-clip-text text-transparent font-semibold" data-id="element-465">
              historia de éxito
            </span>
          </p>
        </motion.div>
        <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        delay: 1
      }} className="absolute bottom-10 left-1/2 -translate-x-1/2" data-id="element-466">
          <motion.div animate={{
          y: [0, 10, 0]
        }} transition={{
          duration: 2,
          repeat: Infinity
        }} className="text-white" data-id="element-467">
            <ArrowRightIcon className="h-8 w-8 rotate-90" data-id="element-468" />
          </motion.div>
        </motion.div>
      </section>
      {/* Filter Categories */}
      <section className="py-16 bg-gray-900" data-id="element-469">
        <div className="container mx-auto px-4 md:px-6" data-id="element-470">
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8
        }} viewport={{
          once: true
        }} className="flex flex-wrap justify-center gap-4" data-id="element-471">
            {categories.map(category => <button key={category.id} onClick={() => setSelectedCategory(category.id)} className={`flex items-center gap-2 px-6 py-3 rounded-full font-semibold transition-all duration-300 ${selectedCategory === category.id ? 'bg-gradient-to-r from-purple-600 to-pink-600 text-white shadow-lg shadow-purple-500/50' : 'bg-gray-800 text-gray-300 hover:bg-gray-700'}`} data-id="element-472">
                {category.icon}
                <span data-id="element-473">{category.name}</span>
              </button>)}
          </motion.div>
        </div>
      </section>
      {/* Projects Grid with 3D Flip Effect */}
      <section className="py-32 bg-gray-900" data-id="element-474">
        <div className="container mx-auto px-4 md:px-6" data-id="element-475">
          <motion.div initial={{
          opacity: 0,
          y: 50
        }} whileInView={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8
        }} viewport={{
          once: true
        }} className="text-center mb-20" data-id="element-476">
            <h2 className="text-4xl md:text-5xl font-bold mb-6 text-white" data-id="element-477">
              Proyectos que{' '}
              <span className="bg-gradient-to-r from-purple-400 to-pink-400 bg-clip-text text-transparent" data-id="element-478">
                marcan la diferencia
              </span>
            </h2>
            <p className="text-xl text-gray-400 max-w-3xl mx-auto" data-id="element-479">
              Cada proyecto es una historia de éxito y transformación
            </p>
          </motion.div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-480">
            {filteredProjects.map((project, index) => <motion.div key={project.id} initial={{
            opacity: 0,
            y: 50
          }} whileInView={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.8,
            delay: index * 0.1
          }} viewport={{
            once: true
          }} className="h-[500px]" style={{
            perspective: '1000px'
          }} onMouseEnter={() => setHoveredProject(project.id)} onMouseLeave={() => setHoveredProject(null)} data-id="element-481">
                <div className="relative w-full h-full transition-transform duration-700 cursor-pointer" style={{
              transformStyle: 'preserve-3d',
              transform: hoveredProject === project.id ? 'rotateY(180deg)' : 'rotateY(0deg)'
            }} data-id="element-482">
                  {/* Front Face - Image */}
                  <div className="absolute inset-0 rounded-2xl overflow-hidden shadow-xl" style={{
                backfaceVisibility: 'hidden'
              }} data-id="element-483">
                    <img src={project.image} alt={project.title} className="w-full h-full object-cover" data-id="element-484" />
                    <div className="absolute inset-0 bg-gradient-to-t from-gray-900 via-gray-900/50 to-transparent" data-id="element-485"></div>
                    <div className="absolute bottom-0 left-0 right-0 p-6" data-id="element-486">
                      <span className="text-sm font-semibold text-purple-400 uppercase tracking-wider" data-id="element-487">
                        {categories.find(cat => cat.id === project.category)?.name}
                      </span>
                      <h3 className="text-2xl font-bold text-white mt-2" data-id="element-488">
                        {project.title}
                      </h3>
                    </div>
                  </div>
                  {/* Back Face - Information */}
                  <div className="absolute inset-0 rounded-2xl overflow-hidden shadow-xl border-2 border-purple-500" style={{
                backfaceVisibility: 'hidden',
                transform: 'rotateY(180deg)'
              }} data-id="element-489">
                    <div className={`absolute inset-0 bg-gradient-to-br ${project.gradient}`} data-id="element-490"></div>
                    <div className="relative h-full p-8 flex flex-col justify-between text-white overflow-y-auto" data-id="element-491">
                      <div data-id="element-492">
                        <div className="mb-4 text-purple-200" data-id="element-493">
                          {categories.find(cat => cat.id === project.category)?.icon}
                        </div>
                        <h3 className="text-2xl md:text-3xl font-bold mb-4" data-id="element-494">
                          {project.title}
                        </h3>
                        <p className="text-white/95 mb-6 text-base md:text-lg leading-relaxed" data-id="element-495">
                          {project.description}
                        </p>
                      </div>
                      <div data-id="element-496">
                        <div className="mb-6 pb-4 border-t border-white/20 pt-4" data-id="element-497">
                          <p className="text-sm font-semibold text-white/70 uppercase tracking-wider mb-1" data-id="element-498">
                            Cliente
                          </p>
                          <p className="text-lg font-bold" data-id="element-499">{project.client}</p>
                        </div>
                        <div className="flex items-center text-white font-semibold" data-id="element-500">
                          <span data-id="element-501">Ver detalles</span>
                          <ArrowRightIcon className="ml-2 h-5 w-5" data-id="element-502" />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </motion.div>)}
          </div>
        </div>
      </section>
      {/* CTA Section */}
      <section className="relative h-screen flex items-center justify-center" data-id="element-503">
        <div className="absolute inset-0" data-id="element-504">
          <img src="https://images.unsplash.com/photo-1519389950473-47ba0277781c?ixlib=rb-4.0.3&auto=format&fit=crop&w=2070&q=80" alt="Contact" className="w-full h-full object-cover" data-id="element-505" />
          <div className="absolute inset-0 bg-gradient-to-b from-gray-900/80 via-purple-900/90 to-gray-900/80" data-id="element-506"></div>
        </div>
        <motion.div initial={{
        opacity: 0,
        y: 50
      }} whileInView={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 1
      }} viewport={{
        once: true
      }} className="container mx-auto px-4 md:px-6 text-center relative z-10" data-id="element-507">
          <h2 className="text-4xl md:text-6xl font-bold mb-6 text-white" data-id="element-508">
            ¿Listo para crear
            <br data-id="element-509" />
            <span className="bg-gradient-to-r from-purple-400 to-pink-400 bg-clip-text text-transparent" data-id="element-510">
              tu próximo proyecto?
            </span>
          </h2>
          <p className="text-xl md:text-2xl text-gray-300 mb-12 max-w-3xl mx-auto" data-id="element-511">
            Estamos aquí para convertir tu visión en realidad
          </p>
          <Button href="/contacto" variant="primary" size="lg" className="bg-gradient-to-r from-purple-600 to-pink-600 hover:from-purple-700 hover:to-pink-700 text-lg px-8 py-4" data-id="element-512">
            Comienza tu proyecto
            <ArrowRightIcon className="ml-2 h-5 w-5" data-id="element-513" />
          </Button>
        </motion.div>
      </section>
    </>;
};
export default Projects;